<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />

    <div v-if="displayLayout===2">
      <NavbarTop v-if="!hideLayout" class="header-container" />

      <div class="mainTop">
        <SidebarTop v-if="!hideLayout" class="sidebarTop" />
        <div class="main">
          <NavMain class="navmain" />
          <app-main class="appmain" />
        </div>
      </div>
    </div>

    <div v-else>
      <sidebar v-if="!hideLayout" class="sidebar-container" />
      <div class="main-container">
        <navbar v-if="!hideLayout" />
        <app-main />
      </div>
    </div>
  </div>
</template>

<script>
import {
  Navbar,
  Sidebar,
  AppMain,
  SidebarTop,
  NavbarTop,
  NavMain
} from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { getQueryParam } from "@/utils/global";
import { envInfo } from "@/constants/envInfo";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    SidebarTop,
    NavbarTop,
    NavMain
  },
  mixins: [ResizeMixin],
  data() {
    return {
      // 是否隐藏layout，当为true时，只显示主操作区域
      hideLayout: false
    };
  },
  computed: {
    sitemapList() {
      return this.$store.state.user.sitemapList;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    displayLayout() {
      return this.$store.state.app.displayLayout;
    },
    device() {
      return this.$store.state.app.device;
    },
    selectMenuId() {
       for( let item of this.sitemapList){
          if (item.sitemapId == this.$store.state.app.selectMenuId && item.nodes) {
            return true;
          }
       }
       return false;
    },
    classObj() {
      return {
        hideLayout: this.hideLayout,
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        noActive: !this.selectMenuId,
        mobile: this.device === "mobile"
      };
    }
  },
  created() {
    // 当前url中指定layout=hide,则隐藏layout，只显示主操作区域
    this.hideLayout = getQueryParam("layout") === "hide";
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("CloseSideBar", { withoutAnimation: false });
    }
  },
  watch: {
    //监听路由，点击个人中心时关闭侧边栏
    $route() {
      if (this.$route.path === envInfo.sitemap.personalCenter.href) {
        this.$store.commit("SET_SELECT_MENU_ID", null);
      }else{
        for( let item of this.sitemapList){
        if (item.href == this.$route.path) {
        this.$store.commit("SET_SELECT_MENU_ID", item.sitemapId+'');
      }
     }
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
